__turbopack_context__.v({
  "badge": "NotificationBell-module-scss-module__1KCRka__badge",
  "button": "NotificationBell-module-scss-module__1KCRka__button",
  "popover": "NotificationBell-module-scss-module__1KCRka__popover",
  "srOnly": "NotificationBell-module-scss-module__1KCRka__srOnly",
  "wrap": "NotificationBell-module-scss-module__1KCRka__wrap",
});
